import {mapState} from 'vuex';

export const rateColorMixin = {

    computed: {

        ...mapState('PanelSettings', [
            'settings'
        ]),
    },

    methods: {

        calculateResponseRateColor(responseRate) {
            const threshold = Math.round(this.settings.poor_response_rate);
            return this.calculateColor(threshold, responseRate);
        },

        calculateStartRateColor(completionRate) {
            const threshold = Math.round(this.settings.poor_start_rate);
            return this.calculateColor(threshold, completionRate);
        },

        calculateColor(threshold, percent)
        {
            if (threshold === 0) return null;

            if (percent === 0) return '#888888';
            if (percent < threshold) return '#C62828';
            if (percent >= threshold && percent < threshold + 10) return '#F9A825';

            return '#4CAF50';
        }
    }
};